import { render } from "./EstadosPendientesPage.vue?vue&type=template&id=91755f80"
import script from "./EstadosPendientesPage.vue?vue&type=script&lang=js"
export * from "./EstadosPendientesPage.vue?vue&type=script&lang=js"

import "./EstadosPendientesPage.vue?vue&type=style&index=0&id=91755f80&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__